<template>
  <div class="page-effect position-relative">
    <section
      v-if="EventsData && EventsData[0]"
      class="register-page-wrapper body-content event-reg-speakers"
      style="background-color: #ffffff"
    >
      <div class="container reg-v2reg px-mob-0">
        <div class="col-lg-10 mx-auto">
          <div class="row">
            <div class="col-lg-12 mob-py-0">
              <!-- <div class="top-right-login text-right hdr-btn mb-md-3 login-ico">
                <a
                  v-show="Config.LandingPageShowEventListLink"
                  v-on:click="goForEventList"
                  class="event-List mob-my-0"
                  >Event List</a
                >
                <a v-on:click="goForLogin" class="login mob-my-0">Login</a>
              </div> -->
              <div class="event_banner position-relative">
                <!-- <img src="images/event-banner.jpg" alt="e2m" /> -->
                <!-- <img id="imgBanner" v-bind:src="BannerURL" alt="e2m" /> -->
                <span
                  class="position-absolute p-2"
                  style="
                    right: 0;
                    top: 0;
                    z-index: 1;
                    color: #fff;
                    font-size: 15px;
                    letter-spacing: 1px;
                    font-weight: 600;
                    cursor: pointer;
                    background: #999;
                    border-radius: 0 10px;
                  "
                  @click.stop="ShowSocialShare"
                >
                  <v-icon color="#fff" size="30px"> mdi-share-outline </v-icon>
                  SHARE
                </span>
                <img
                  id="imgBannerEvnt"
                  :src="EventsData.length > 0 ? EventsData[0].EventLogo : ''"
                />
                <!-- <v-file-input
                  v-if="isAdminComponent && showLogoUploader"
                  label="Change Image, Recommended Size(960/192)"
                  filled
                  prepend-icon="mdi-camera"
                  accept="image/*"
                  @change="
                    $parent.update_logo($event, '960x192', {
                      key: 'EventLogo',
                      field: 'EventsData',
                    })
                  "
                ></v-file-input> -->
                <a
                  class="circle_blink_button"
                  v-if="isAdminComponent && !showLogoUploader"
                  @click="showLogoUploader = true"
                  ><span>&nbsp;</span></a
                >
              </div>
              <div class="row">
                <div class="col-lg-8 col-md-6">
                  <h1 class="page-head mb-2" v-if="EventsData && EventsData[0]">
                    {{ EventsData[0].EventFullName }}
                  </h1>
                  &nbsp;
                  <div class="top-right-login ml-n4">
                    <!-- <a
                      href="javascript:void(0);"
                      style="pointer-events: none"
                      class="event-List"
                      v-if="EventsData[0]"
                      >{{ EventsData[0].EventStartDateZ }}&nbsp; to &nbsp;{{
                        EventsData[0].EventEndDateZ
                      }}
                      &nbsp;{{ EventsData[0].EventTimezoneZ }}</a
                    > -->
                    <AddEventToCalendar
                      v-if="EventsData && EventsData[0]"
                      :addToCalendarLabel="EventsData[0].EventDateStringLabel"
                      :displayLabel="true"
                      :eventTitle="EventsData[0].EventFullName"
                      :eventStartTimestamp="EventsData[0].EventStartTimestamp"
                      :eventEndTimestamp="EventsData[0].EventEndTimestamp"
                    />
                  </div>
                </div>
                <!-- v-on:click="goForRegister" -->
                <div class="col-lg-4 col-md-6 text-md-right reg-v2-r-w">
                  <p class="text-left mb-1">
                    <!-- <span class="text-m">
                      {{
                        getMaxMinPrice.minPrice
                          ? `From ${getcurrency}${getMaxMinPrice.minPrice}`
                          : "FREE"
                      }}
                    </span>
                    <span class="text-m">
                      {{
                        getMaxMinPrice.maxPrice
                          ? `To ${getcurrency}${getMaxMinPrice.maxPrice}`
                          : ""
                      }}
                    </span> -->
                  </p>
                  <!-- <button
                    v-if="
                      RegistrationTypes.length == 1 &&
                      RegistrationTypes[0].MaxLimit == 1
                    "
                    id="btnRegister"
                    type="submit"
                    class="btn reg-button text-uppercase"
                    style="
                      background: #288af2 !important;
                      color: #fff !important;
                    "
                    @click.prevent="directFormOpen"
                  >
                    Register for the event
                  </button> -->
                  <v-btn
                    v-if="
                      RegistrationTypes.length == 1 &&
                      RegistrationTypes[0].MaxLimit == 1
                    "
                    id="btnRegister"
                    class="btn reg-button text-uppercase"
                    :disabled="!AllowRegistration"
                    style="
                      background: #288af2;
                      color: #fff !important;
                      font-size: 16px;
                      padding: 10px 25px;
                      height: 44px;
                      letter-spacing: unset;
                    "
                    @click.prevent="directFormOpen"
                    :loading="IsSubmitting"
                  >
                    {{ RegisterButtonText }}
                  </v-btn>
                  <!-- data-target="#register_popup" -->
                  <button
                    v-else
                    id="btnRegister"
                    type="submit"
                    class="btn reg-button text-uppercase"
                    data-toggle="modal"
                    :disabled="!AllowRegistration"
                    style="background: #288af2; color: #fff !important"
                    @click="OpenCheckoutForm"
                  >
                    {{ RegisterButtonText }}
                  </button>
                </div>
              </div>
            </div>
            <div
              v-show="Config && Config.LandingPageShowHostedByPanel"
              class="col-md-12 pt-0"
            >
              <div
                class="media border p-4 full-width hosted-box align-items-center"
              >
                <!-- <img
                           src="images/reg-banner.jpg"
                           alt="John Doe"
                           class="mr-3 rounded-circle"
                           style="width:60px;height: 60px;"
                           />-->
                <label class="imageCircle reg-prof-img new-reg p-2 rounded">
                  <img id="imgBanner" v-bind:src="HostInfo.Logo" />
                  <!--link plus icon-->
                  <a
                    class="circle_blink_button"
                    v-if="isAdminComponent && !showEditor"
                    @click="showHostedByPopup = true"
                    ><span>&nbsp;</span></a
                  >
                  <!--link plus end-->
                </label>
                <div class="media-body pl-2 border-r-none">
                  <h6>Hosted By</h6>
                  <h5>{{ HostInfo.Name }}</h5>
                  <!--link plus icon-->
                  <a
                    class="circle_blink_button"
                    v-if="isAdminComponent && !showEditor"
                    @click="showHostedByPopup = true"
                    ><span>&nbsp;</span></a
                  >
                  <!--link plus end-->
                </div>
                <p
                  v-html="HostInfo.Profile"
                  class="m-0 border-left pr-2 pl-3"
                ></p>
              </div>
            </div>
            <!---------->
          </div>
          <!------tab area start-------->
          <section
            class="session-list-wrapper p-0 mt-3 SessionlistMultitracker"
          >
            <div class="reg-page-tab-hld reg-menu">
              <ul class="nav nav-tabs mb-4 pl-0" role="tablist">
                <li class="nav-item">
                  <a
                    class="nav-link active acnhDescription"
                    data-toggle="tab"
                    href="#description"
                    >description</a
                  >
                </li>
                <li
                  class="nav-item"
                  v-if="isAdminComponent || adminSettings.ShowSessionTab"
                  @click="SessionsLoaded"
                >
                  <a
                    class="nav-link acnhDescription"
                    data-toggle="tab"
                    href="#Sessions"
                    >Sessions</a
                  >
                  <v-switch
                    v-if="isAdminComponent"
                    class="m-0 p-0"
                    @change="$parent.setAdminSettings(adminSettings)"
                    v-model="adminSettings.ShowSessionTab"
                  />
                </li>
                <li
                  class="nav-item"
                  v-if="isAdminComponent || adminSettings.ShowSpeakerTab"
                  @click="SpeakersLoaded"
                >
                  <a
                    class="nav-link acnhDescription"
                    data-toggle="tab"
                    href="#SpeakersHost"
                    >Speakers</a
                  >
                  <v-switch
                    v-if="isAdminComponent"
                    class="m-0 p-0"
                    @change="$parent.setAdminSettings(adminSettings)"
                    v-model="adminSettings.ShowSpeakerTab"
                  />
                </li>
              </ul>
              <!------tab content start------>

              <div class="tab-content ss-t-content" style="min-height: 200px">
                <div
                  id="description"
                  v-if="EventsData[0]"
                  class="tab-pane active p-r"
                >
                  <ckeditor
                    v-if="isAdminComponent && showEditor"
                    class="desc-event"
                    v-model="EventsData[0].Description"
                    :config="editorConfig"
                  >
                  </ckeditor>
                  <div
                    v-else-if="EventsData[0].Description"
                    v-html="EventsData[0].Description"
                  ></div>
                  <div v-else class="overview-info-msg-box">
                    <h5 class="text-left">Your Description will appear here</h5>
                    <!-- <h5 class="text-left" style="color: rgb(139, 139, 139)">
                      Unlock great new opportunities!
                    </h5> -->
                  </div>
                  <div
                    class="d-flex justify-center mt-5"
                    v-if="isAdminComponent"
                  >
                    <v-btn
                      v-if="showEditor"
                      color="black"
                      outlined
                      class="px-5 mr-3 py-4"
                      @click="showEditor = false"
                      >CANCEL</v-btn
                    >
                    <v-btn
                      v-if="showEditor"
                      color="primary"
                      class="px-6 py-4"
                      @click="
                        showEditor = false;
                        $parent.saveEventinfo(EventsData[0], HostInfo);
                      "
                      >SAVE</v-btn
                    >
                  </div>
                  <a
                    class="circle_blink_button"
                    v-if="isAdminComponent && !showEditor"
                    @click="showEditor = true"
                    ><span>&nbsp;</span></a
                  >
                </div>
                <div id="Sessions" class="tab-pane fade p-r">
                  <SessionsAdmin
                    v-if="isAdminComponent"
                    ref="adminSessionList"
                    :key="adminsessionsListKey"
                    :isRegistrationComponent="true"
                  ></SessionsAdmin>
                  <iframe
                    v-if="
                      !isAdminComponent && currentDomain && clientID && eventID
                    "
                    id="divPublicSessions"
                    style="width: 100%; min-height: 100px; border: 0"
                    @load="SessionsLoaded"
                    :src="
                      currentDomain +
                      '/widget/PublicSessions.html?env=' +
                      Environment() +
                      '&c=' +
                      clientID +
                      '&e=' +
                      eventID +
                      '&o=1' +
                      '&date_group=1' +
                      '&hide_join_button=1' +
                      '&no_background=1' +
                      '&external_session_details_popup=' +
                      external_session_details_popup +
                      '&hide_speaker_enabled=' +
                      hide_speaker_enabled +
                      '&t=' +
                      cts
                    "
                  />
                  <!-- <iframe
            v-if="currentDomain && clientId && selectedEventId"
            id="divPublicSessions"
            style="width: 100%; min-height: 100px; border: 0"
            @load="SessionsLoaded"
            :src="
              currentDomain +
              '/widget/PublicSessions.html?env=' +
              environment +
              '&c=' +
              clientId +
              '&e=' +
              selectedEventId +
              '&o=' +
              tabOrientation +
              '&tab_hash_tag=' +
              tab_hash_tag +
              '&date_group=' +
              date_group +
              '&external_session_details_popup=' +
              external_session_details_popup +
              '&donot_show_details_popup=' +
              donot_show_details_popup +
              '&join_inperson_session_anytime=' +
              join_inperson_session_anytime +
              '&allow_guest_join_inperson_session=' +
              allow_guest_join_inperson_session +
              '&session_date_format=' +
              session_date_format +
              '&hide_speaker_enabled=' +
              hide_speaker_enabled
            "
          /> -->
                  <Sessions
                    v-if="false"
                    ref="sessionList"
                    :key="sessionsListKey"
                    :isAdminComponent="false"
                    :isRegistrationComponent="true"
                    :eventCollectionName="eventCollectionName"
                    :eventFullName="EventsData[0].EventFullName"
                    :eventTimeZone="eventTimeZone"
                  ></Sessions>
                </div>
                <!--session tab end-->
                <div id="SpeakersHost" class="tab-pane fade p-r">
                  <AdminSpeakerList
                    v-if="isAdminComponent"
                    ref="adminSpeeakerList"
                    :isRegistrationComponent="true"
                  ></AdminSpeakerList>

                  <iframe
                    v-if="
                      !isAdminComponent && currentDomain && clientID && eventID
                    "
                    id="divPublicSpeakers"
                    style="
                      width: 100%;
                      min-height: 200px;
                      overflow: hidden;
                      padding: 0;
                      border: 0;
                    "
                    :src="
                      currentDomain +
                      '/widget/PublicSpeakers.html?env=' +
                      Environment() +
                      '&c=' +
                      clientID +
                      '&e=' +
                      eventID +
                      '&t=' +
                      cts
                    "
                    @load="SpeakersLoaded"
                  />
                  <SpeakerList
                    v-else-if="false"
                    ref="speeakerList"
                    :key="speeakerListKey"
                    :isAdminComponent="false"
                    :isRegistrationComponent="true"
                    :eventCollectionName="eventCollectionName"
                    :eventTimeZone="eventTimeZone"
                  ></SpeakerList>
                </div>
              </div>
              <!------tab content end------>
            </div>
          </section>
          <!------tab area end-------->
        </div>
      </div>
    </section>
    <!---register popup-->
    <div
      class="modal fade register_popup"
      id="register_popup"
      tabindex="-1"
      role="dialog"
      aria-labelledby="exampleModalCenterTitle"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
        <div class="modal-content">
          <div
            class="modal-header justify-content-center flex-column align-items-center"
          >
            <h5 class="modal-title" id="exampleModalLongTitle">
              {{
                EventsData && EventsData[0] && EventsData[0].EventFullName
                  ? EventsData[0].EventFullName
                  : ""
              }}
            </h5>
            <p>
              {{ EventsData[0].EventStartDateZ }} -
              {{ EventsData[0].EventEndDateZ }}
              {{ EventsData[0].EventTimezoneZ }}
            </p>
            <!-- <p>
              freeTicketSelected:{{ freeTicketSelected
              }}<br />paidTicketSelected:{{ paidTicketSelected }}
            </p> -->
            <!-- data-dismiss="modal" -->
            <button
              type="button"
              class="close"
              ref="close_modal"
              aria-label="Close"
              @click="CloseCheckoutForm"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="row reg-row mt-0" v-if="RegistrationTypes.length">
              <div class="col-lg-7 col-md-7 reg-left-side">
                <!---box start-->
                <div
                  class="d-flex justify-content-between align-items-center"
                  v-for="(item, index) in RegistrationTypes"
                  :key="index"
                >
                  <div class="reg_box_inner_l">
                    <h2>
                      {{ item.RegistrationType }}
                    </h2>
                    <p v-if="item.FormType.toLowerCase() == 'paid'">
                      <span class="text-m" style="font-size: 2em"
                        >{{ item.Currency.symbol }} {{ item.Price }}</span
                      >
                      {{
                        item.PriceIncludingTax == false
                          ? `+ Taxes ${item.Tax}%`
                          : ""
                      }}
                    </p>
                    <p v-else><span class="text-m">Free</span></p>
                    <div v-html="item.Description"></div>
                    <p
                      v-show="
                        !['E1666196359265', 'E1667290052589'].includes(eventID)
                      "
                    >
                      Sale from
                      {{
                        (item.SaleStartDate._seconds
                          ? item.SaleStartDate._seconds * 1000
                          : item.SaleStartDate) | momentConvert
                      }}
                      to
                      {{
                        (item.SaleEndDate._seconds
                          ? item.SaleEndDate._seconds * 1000
                          : item.SaleEndDate) | momentConvert
                      }}
                    </p>
                  </div>
                  <div
                    class="reg_box_inner_r red--text"
                    v-if="item.isInActiveTicket"
                  >
                    {{ item.InActiveMessage }}
                  </div>
                  <div v-else class="reg_box_inner_r">
                    <div class="form-group mb-0">
                      <select
                        class="form-control"
                        v-model="item.selectedQuantity"
                        :disabled="
                          IsTicketDisabled(
                            item.RegistrationTypeId,
                            item.selectedQuantity
                          )
                        "
                      >
                        <option :value="0" :key="0" selected="selected">
                          0
                        </option>
                        <option
                          v-for="oindex in Number(item.MaxLimit)"
                          :key="oindex"
                          :value="oindex"
                        >
                          {{ oindex }}
                        </option>
                      </select>
                    </div>
                  </div>
                </div>
                <!---box end-->
              </div>
              <div class="col-lg-5 col-md-5 reg-right-side">
                <div class="reg-r-inner-w border">
                  <v-img
                    id="imgBannerEvnt"
                    :src="EventsData.length > 0 ? EventsData[0].EventLogo : ''"
                  />
                  <!-- <h4>Order Summary</h4> -->
                  <h4>Summary</h4>
                  <!-- <p class="d-flex justify-content-between  mb-2"><span>1 x Generel Admission</span> <span>US$ 0.00</span></p> -->
                  <table class="full-width">
                    <tr v-for="(item, index) in RegistrationTypes" :key="index">
                      <td
                        style="text-align: left"
                        v-if="Number(item.selectedQuantity)"
                      >
                        {{ item.selectedQuantity }} x
                        {{ item.RegistrationType }}
                      </td>
                      <td
                        v-if="
                          item.FormType == 'Paid' &&
                          Number(item.selectedQuantity)
                        "
                        style="white-space: nowrap"
                      >
                        {{ item.Currency.symbol }}
                        {{
                          (
                            Number(item.selectedQuantity) * Number(item.Price)
                          ).toFixed(2)
                        }}
                      </td>
                      <td
                        v-if="
                          item.FormType == 'Free' &&
                          Number(item.selectedQuantity)
                        "
                      >
                        Free
                      </td>
                    </tr>
                    <tr>
                      <td>Sub Total</td>
                      <td>
                        {{ getcurrency }} {{ Number(getsubtotal).toFixed(2) }}
                      </td>
                    </tr>
                    <tr v-if="getsubtotal">
                      <td>Taxes</td>
                      <td style="white-space: nowrap">
                        {{ getcurrency }} {{ Number(taxPrice).toFixed(2) }}
                      </td>
                    </tr>
                    <tr>
                      <td colspan="2" class="position-relative">
                        <div class="circle circle-cu-left"></div>
                        <div class="circle circle-cu-right"></div>
                        <hr />
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <h2>Total</h2>
                      </td>
                      <td>
                        <h2 style="white-space: nowrap">
                          {{ getcurrency }}
                          {{
                            (Number(getsubtotal) + Number(taxPrice)).toFixed(2)
                          }}
                        </h2>
                      </td>
                    </tr>
                  </table>
                  <div class="register-page-wrapper">
                    <!--mobile only-->
                    <div
                      class="d-md-none align-items-center justify-content-between"
                    >
                      <h5 class="text-left pr-2">
                        Total
                        <span
                          class="text-m d-block pt-1"
                          style="white-space: nowrap"
                          >{{ getcurrency }}
                          {{
                            (Number(getsubtotal) + Number(taxPrice)).toFixed(2)
                          }}</span
                        >
                      </h5>
                    </div>
                    <v-btn
                      :loading="IsSubmitting"
                      class="btn reg-button reg-button"
                      style="color: #fff; font-size: 16px"
                      @click="goForRegister"
                    >
                      {{ CheckoutButtonText }}
                    </v-btn>
                  </div>
                </div>
              </div>
            </div>
            <div class="align-items-center justify-content-center" v-else>
              <h3>No Registration Type Available!</h3>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!---hosted by-->

    <v-dialog v-model="showHostedByPopup" max-width="1000">
      <v-card>
        <v-card-text style="overflow-y: auto">
          <div
            class="hosted-section2 mt-3 position-relative"
            v-if="isAdminComponent && showHostedByPopup"
          >
            <h3>Hosted By<span>(Optional)</span></h3>
            <v-btn
              fab
              icon
              small
              class="close-dialog"
              @click="showHostedByPopup = false"
              ><v-icon size="25px" color="#333">mdi-close</v-icon></v-btn
            >
            <div class="inner-host-by-wrap">
              <v-row class="mt-8">
                <v-col md="6" sm="6" cols="12">
                  <label>Host Name</label>
                  <v-text-field
                    placeholder="Enter host name"
                    v-model="HostInfo.Name"
                    :rules="blankRules"
                    required
                  ></v-text-field>
                  <label>Host Short profile</label>
                  <ckeditor
                    class="desc-event"
                    v-model="HostInfo.Profile"
                    :config="editorConfig"
                  >
                  </ckeditor>
                </v-col>
                <v-col md="6" sm="6" cols="12">
                  <div class="drag-drop-sponsor-logo">
                    <input
                      type="file"
                      value=""
                      class="select-file"
                      accept="image/*"
                      @change="
                        $parent.update_logo($event, '960x192', {
                          key: 'Logo',
                          field: 'HostInfo',
                        })
                      "
                    />
                    <img v-if="HostInfo.Logo" :src="HostInfo.Logo" />
                    <img v-else src="../assets/Images/reg-ico/img-icon.svg" />
                    <h4>click to add host logo</h4>
                    <p>960x192px PNG, JPG Max 3MB</p>
                  </div>
                </v-col>
              </v-row>
            </div>
          </div>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="black"
            outlined
            class="px-5 mr-2 py-4 cancel-standard"
            @click="showHostedByPopup = false"
            width="100px"
            >CANCEL</v-btn
          >
          <v-btn
            color="primary"
            @click="
              showHostedByPopup = false;
              $parent.saveEventinfo(EventsData[0], HostInfo);
            "
            class="save-standard"
            width="100px"
          >
            Save
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!--- LOGO UPLOADER -->
    <v-dialog v-model="showLogoUploader">
      <v-card>
        <v-card-text style="max-height: 400px; overflow-y: auto">
          <div
            class="hosted-section mt-3"
            v-if="isAdminComponent && showLogoUploader"
          >
            <h3>Upload Logo</h3>
            <v-row class="mt-8">
              <v-col md="12" sm="12" cols="12">
                <div class="drag-drop-sponsor-logo">
                  <input
                    type="file"
                    value=""
                    class="select-file"
                    accept="image/*"
                    @change="
                      $parent.update_logo($event, '960x192', {
                        key: 'EventLogo',
                        field: 'EventsData',
                      });
                      showLogoUploader = false;
                    "
                  />
                  <img src="../assets/Images/reg-ico/img-icon.svg" />
                  <h4>click to add logo</h4>
                  <p>960x192px PNG, JPG Max 3MB</p>
                </div>
              </v-col>
            </v-row>
          </div>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="black"
            outlined
            class="px-5 mr-3 py-4"
            @click="showLogoUploader = false"
            >CANCEL</v-btn
          >
          <!-- <v-btn color="primary" @click="showLogoUploader = false">
            Save
          </v-btn> -->
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="sessionDetailsPopup"
      width="1000px"
      content-class="reg-options-whole position-relative"
    >
      <v-card>
        <v-btn
          class="goto-option-close"
          icon
          @click="sessionDetailsPopup = false"
          ><v-icon color="#333" size="25px">mdi-close</v-icon></v-btn
        >
        <v-card-text class="p-0">
          <SessionDetails
            id="snDtls"
            :key="sessionDetailsKey"
            :sn="currentSession"
            :isPublicPage="isPublicPage"
            :hide_speaker_enabled="hide_speaker_enabled"
          ></SessionDetails>
          <!-- 
            //:hide_speaker_enabled="1"@goToSession="goToSession" -->
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
  <!------------>
</template>
<style>
#success-modal span.btn-pink.sussecc-btn {
  margin-top: 15px;
}
.new-btn-design {
  display: inline-flex;
  justify-content: center;
  align-items: center;
  flex-direction: row;
  margin-left: 15px;
  padding: 8px 12px 8px 0;
  min-width: auto;
  background: #19a883;
  border-radius: 5px;
}
.new-btn-design img {
  border-right: 1px solid rgba(255, 255, 255, 0.4);
  padding: 0 12px;
}
.new-btn-design span {
  color: #fff;
  font-weight: 600 !important;
  font-size: 14px !important;
  margin-left: 10px !important;
}
.new-btn-design-disabled {
  opacity: 1;
  background: #d4d6d7 !important;
}
.three-session #dvBroadcast {
  justify-content: flex-start;
}
.email-body {
  height: 300px;
  overflow-y: scroll;
}
#btnRegister.v-btn--disabled {
  background-color: grey !important;
}
</style>

<script>
import jQuery from "jquery";
let $ = jQuery;
import { bus } from "@/main";
import APIs from "@/components/APIInit";
// import db from "../components/firebaseInit";
import router from "../router";
var self;
// import Vue from "vue";
// import VueMoment from "vue-moment";
import moment from "moment-timezone";
import firebase from "firebase";
import axios from "axios";
import CKEditor from "ckeditor4-vue";
import CKconfig from "@/assets/ckeditor-config.ts";

import SpeakerList from "@/views/SpeakerList.vue";
import AdminSpeakerList from "@/views/AdminSpeakerList.vue";

import Sessions from "@/views/sessions.vue";
import SessionsAdmin from "@/views/SessionsAdmin.vue";
import AddEventToCalendar from "@/components/AddToCalendar.vue";
import SessionDetails from "@/components/SessionDetails.vue";
//import Vue from "vue";

let ticketStatusUpdateTimer;
export default {
  components: {
    ckeditor: CKEditor.component,
    SpeakerList,
    AdminSpeakerList,
    Sessions,
    SessionsAdmin,
    AddEventToCalendar,
    SessionDetails,
  },
  props: {
    isAdminComponent: {
      type: Boolean,
      default: false,
    },
  },
  watch: {},
  data() {
    return {
      app: "false",
      showLogoUploader: false,
      showHostedByPopup: false,
      HostInfo: {
        Name: null,
        Profile: null,
        Logo: null,
      },
      blankRules: [(v) => !!v || "This field is required"],
      showEditor: false,
      adminsessionsListKey: 0,
      sessionsListKey: 0,
      speeakerListKey: 0,
      sessionList: [],
      adminSettings: {
        ShowSessionTab: false,
        ShowSpeakerTab: false,
      },
      editorConfig: CKconfig.editorConfig,
      currentTab: "description",
      AllowRegistration: true,
      ShowEventListLink: true,
      ShowHostedByPanel: true,
      eventCollectionName: "",
      eventTimeZone: "",
      btntextColor: "black",
      btnBackColor: "#ef222b",
      BannerURL: "",
      desktopBanner: "",
      mobileBanner: "",
      EventsData: [],
      clientID: "",
      clientName: "",
      hostName: "",
      clientLogoUrl: "",
      eventID: "",
      clientProfile: "",
      customDomain: "",
      ticketStatus: 0,
      RegistrationTypes: [],
      CheckoutForms: [],
      taxPrice: 0,
      Config: {
        PayingToLogo: this.clientLogo,
        SubmitButtonDisplaylabel: "SUBMIT",
        PayingTo: this.clientName,
        LandingPageShowHostedByPanel: false,
        LandingPageShowEventListLink: false,
      },
      IsSubmitting: false,
      getCheckoutFormsRetryCount: 0,
      sessionDetailsKey: 0,
      sessionDetailsPopup: false,
      currentSession: null,

      external_session_details_popup: 1,
      donot_show_details_popup: 0,
      join_inperson_session_anytime: 1,
      allow_guest_join_inperson_session: 1,
      session_date_format: 0,
      hide_speaker_enabled: 1,
      isPublicPage: true,
      cts: 0,

      paidTicketSelected: false,
      freeTicketSelected: false,
    };
  },
  computed: {
    currentDomain() {
      return location.origin;
    },
    getsubtotal() {
      let vm = this;
      vm.taxPrice = 0;
      return this.RegistrationTypes.reduce((preval, item) => {
        let price = item.Price ? item.Price : 0;
        if (item.PriceIncludingTax == false)
          vm.taxPrice = (
            Number(vm.taxPrice) +
            (Number(item.selectedQuantity) * Number(price) * item.Tax) / 100
          ).toFixed(2);
        return preval + Number(item.selectedQuantity) * Number(price);
      }, 0);
    },
    getcurrency() {
      var result = "$";
      let type = this.RegistrationTypes.filter((item) => {
        return (
          item.Currency &&
          item.selectedQuantity > 0 &&
          item.FormType.toLowerCase() == "paid"
        );
      });
      if (type.length > 0 && type[0].Currency) {
        result = type[0].Currency.symbol;
      }
      return result;
    },
    getMaxMinPrice() {
      let minPrice = 0;
      let maxPrice = 0;
      this.RegistrationTypes.forEach((item, index) => {
        if (index > 0) {
          minPrice =
            item.Price && item.Price < minPrice ? item.Price : minPrice;
          maxPrice =
            item.Price && item.Price > maxPrice ? item.Price : maxPrice;
        } else {
          maxPrice = item.Price || 0;
        }
      });
      return { minPrice: Number(minPrice), maxPrice: Number(maxPrice) };
    },
    getOneFormsMaxMinLimit() {
      let MinLimit = 1;
      let MaxLimit = 1;
      this.CheckoutForms[0].RegistrationTypes.forEach((item, index) => {
        if (index > 0) {
          MinLimit = item.MinLimit < MinLimit ? item.MinLimit : MinLimit;
          MaxLimit = item.MaxLimit > MaxLimit ? item.MaxLimit : MaxLimit;
        } else {
          MaxLimit = item.MaxLimit;
        }
      });
      return { MinLimit: Number(MinLimit), MaxLimit: Number(MaxLimit) };
    },
    RegisterButtonText() {
      var result = "Register Now";
      if (!self.AllowRegistration) {
        result = "Registration Closed";
      } else if (self.ticketStatus == 1) {
        result = "Sale Not Started!";
      } else if (self.ticketStatus == 3) {
        result = "Sale Ended!";
      } else if (self.ticketStatus == 2) {
        result = "All Tickets Sold!";
      }
      return result;
    },
    CheckoutButtonText() {
      var result = "Checkout";
      if (self.ticketStatus == 1) {
        result = "Sale Not Started!";
      } else if (self.ticketStatus == 3) {
        result = "Sale Ended!";
      } else if (self.ticketStatus == 2) {
        result = "All Tickets Sold!";
      }
      return result;
    },
  },
  filters: {
    momentConvert: function (date) {
      //return moment(new Date(date)).format("MMM dd, hh:MM TT");
      var dateFormat = require("dateformat");
      return dateFormat(new Date(date), "mmm dd, h:MM TT");
    },
  },
  metaInfo() {
    return {
      title:
        this.EventsData &&
        this.EventsData[0] &&
        this.EventsData[0].EventFullName
          ? this.EventsData[0].EventFullName
          : "",
      meta: [
        {
          property: "og:title",
          content:
            this.EventsData &&
            this.EventsData[0] &&
            this.EventsData[0].EventFullName
              ? this.EventsData[0].EventFullName
              : "",
        },
        {
          property: "og:url",
          content: this.customDomain ? this.customDomain : "",
        },
        { property: "og:type", content: "website" },
        { property: "og:description", content: "website" },
        { property: "og:site_name", content: "Epiloge" },
        {
          property: "og:description",
          content:
            this.EventsData &&
            this.EventsData[0] &&
            this.EventsData[0].Description
              ? this.EventsData[0].Description
              : "",
        },
        {
          property: "og:image",
          content:
            this.EventsData &&
            this.EventsData[0] &&
            this.EventsData[0].EventLogo
              ? this.EventsData[0].EventLogo
              : "",
        },
        {
          property: "twitter:card",
          content:
            this.EventsData &&
            this.EventsData[0] &&
            this.EventsData[0].EventFullName
              ? this.EventsData[0].EventFullName
              : "",
        },
        {
          property: "twitter:title",
          content:
            this.EventsData &&
            this.EventsData[0] &&
            this.EventsData[0].EventFullName
              ? this.EventsData[0].EventFullName
              : "",
        },
        {
          property: "twitter:description",
          content:
            this.EventsData &&
            this.EventsData[0] &&
            this.EventsData[0].Description
              ? this.EventsData[0].Description
              : "",
        },
        {
          property: "twitter:url",
          content: this.customDomain ? this.customDomain : "",
        },
        {
          property: "twitter:description",
          content:
            this.EventsData &&
            this.EventsData[0] &&
            this.EventsData[0].Description
              ? this.EventsData[0].Description
              : "",
        },
        {
          property: "twitter:image",
          content:
            this.EventsData &&
            this.EventsData[0] &&
            this.EventsData[0].EventLogo
              ? this.EventsData[0].EventLogo
              : "",
        },
      ],
    };
  },
  beforeCreate() {
    // $("#topmenu").hide();
    // $("#leftmenu").hide();
    // setTimeout(() => {
    //   setTimeout(() => {
    //     setTimeout(() => {
    //       $("#app").addClass("full-screen");
    //     }, 100);
    //     $("#app").addClass("full-screen");
    //   }, 100);
    //   $("#app").addClass("full-screen");
    // }, 100);
    // $("#app").addClass("full-screen");
  },
  created() {
    self = this;
    self.initScreen();
    $(window).resize(function () {
      self.initScreen();
    });
    if (this.$refs.close_modal) {
      this.$refs.close_modal.click();
    }
    const params = new URLSearchParams(window.location.search);
    const app = params.get("app");
    if (app == "true") {
      self.app = "true";
    }
  },
  async mounted() {
    self.cts = new Date().getTime();
    // $("#topmenu").hide();
    // $("#leftmenu").hide();
    // setTimeout(() => {
    //   self.showSnackbar("test", "success", "top");
    // }, 10000);
    $("html, body").animate({ scrollTop: 0 }, 1000);

    $(document).ready(function () {
      window.addEventListener("message", (event) => {
        // let iframe = document.querySelector("#divPublicSessions");
        // iframe.height = event.data.height;
        //alert(typeof event.data);
        if (typeof event.data == "object") {
          if (!event.data.page || event.data.page == "sessions") {
            if (event.data.SessionId) {
              //alert("o: " + event.origin);
              if (event.data.action == "details") {
                //alert("message: " + event.data.action)
                self.sessionDetailsKey++;
                self.sessionDetailsPopup = true;
                self.currentSession = event.data.session;
                //alert("SD:"+self.currentSession.SessionId);
              } else {
                //self.goToSession(event.data);
              }
            } else if (event.data.action == "tabchange") {
              self.resizeSessionFrame();
            }
          } else if (
            event.data.page == "speakers" &&
            event.data.action == "load"
          ) {
            self.resizeSpeakerFrame();
          }
        }
      });
    });
    self.EventsData = [];
    var eventId = this.$route.params.e; // this.$route.query.e;
    self.eventID = eventId;
    console.log(eventId);
    //const storage = firebase.storage();
    //const storageRef = storage.ref();
    const HOSTURL = process.env.VUE_APP_LOCALHOST_URL_EDU;
    if (location.host.toLowerCase().indexOf("localhost") >= 0) {
      self.hostName = HOSTURL ? HOSTURL : self.LocalhostDomain();
    } else {
      self.hostName = HOSTURL ? HOSTURL : location.host;
    }
    var path;
    //console.log(self.hostName);
    //if (this.hostName.toLowerCase().indexOf("uat") > -1) {
    //  path = "https://resources.e2m.live/uate2monair.appspot.com/";
    //} else {
    path = APIs.googleSoragePath;
    //}
    // alert(path);
    axios
      .get(
        path + "OA_UAT%2FClients%2FHosts%2F" + this.hostName + ".json?alt=media"
      )
      .then(async (res) => {
        // debugger;
        if (res && res.data) {
          bus.$emit("EnableHelpChat", "Event", res.data.ClientId);
        }
        console.log("res===1", res.data);
        self.clientID = res.data.ClientId;
        self.clientName = res.data.ClientName;
        self.customDomain = res.data.CustomDomain;
        self.eventCollectionName = `OA_UAT_${self.clientID}${self.eventID}`;
        axios
          .get(
            APIs.EventBrandingJsonData +
              "?iid=OA_UAT" +
              "&cid=" +
              self.clientID +
              "&eid=" +
              self.eventID
          )
          .then(async (res) => {
            console.log("res===2", res.data);
            if (res.data.status == 0 && res.data.result) {
              if (res.data.result.EventInfo) {
                self.eventTimeZone = res.data.result.EventInfo.TimeZone;
              }
              if (res.data.result.ClientInfo) {
                self.desktopBanner =
                  res.data.result.ClientInfo.EventListAssets.banner2048x88;
                self.mobileBanner =
                  res.data.result.ClientInfo.EventListAssets.banner750x103;
                // self.BannerURL =
                //   res.data.result.ClientInfo.EventListAssets.banner2048x88;
              }
              // else {
              //   self.BannerURL == "";
              // }
              self.initScreen();
              var dateFormat = require("dateformat");

              //console.log(res.data.result.EventInfo.EventFullName);
              var obj = new Object();

              obj.eventId = eventId;
              obj.EventFullName = res.data.result.EventInfo.EventFullName;
              obj.IsPublished = res.data.result.EventInfo.IsPublished;
              document.title =
                res.data.result.EventInfo.EventFullName +
                " - " +
                self.clientName;
              // obj.EventTimezone = response.data.EventInfo.TimeZone; // moment.tz.guess();
              obj.EventTimezoneZ = moment.tz.guess();

              console.log(
                "response.data.EventInfo:- " + res.data.result.EventInfo
              );
              obj.EventLogo = res.data.result.EventInfo.EventLogo;
              obj.EventBannerShare = res.data.result.EventInfo.EventBannerShare;
              obj.Description = res.data.result.EventInfo.Description;
              self.AllowRegistration =
                res.data.result.EventInfo.AllowRegistration == undefined
                  ? true
                  : res.data.result.EventInfo.AllowRegistration;
              // obj.EventStartDate = dateFormat(
              //   res.data.result.EventInfo.EventStartDate,
              //   "mmm dd, hh:MM TT"
              // );
              // obj.EventEndDate = dateFormat(
              //   res.data.result.EventInfo.EventEndDate,
              //   "mmm dd, hh:MM TT"
              // );
              debugger;
              obj.EventStartDateZ = self.GetTimeByZone(
                res.data.result.EventInfo.EventStartDate,
                res.data.result.EventInfo.TimeZone
              );
              obj.EventStartTimestamp = parseInt(
                obj.EventStartDateZ.getTime() / 1000
              );
              obj.EventStartDateZ = dateFormat(
                obj.EventStartDateZ,
                "mmm dd, hh:MM TT"
              );
              obj.EventEndDateZ = self.GetTimeByZone(
                res.data.result.EventInfo.EventEndDate,
                res.data.result.EventInfo.TimeZone
              );
              obj.EventEndTimestamp = parseInt(
                obj.EventEndDateZ.getTime() / 1000
              );
              obj.EventEndDateZ = dateFormat(
                obj.EventEndDateZ,
                "mmm dd, hh:MM TT"
              );
              obj.EventStartDate = dateFormat(
                obj.EventStartDateZ,
                "mmm dd, hh:MM TT"
              );
              obj.EventEndDate = dateFormat(
                obj.EventEndDateZ,
                "mmm dd, hh:MM TT"
              );
              obj.EventDateStringLabel =
                obj.EventStartDate.substr(0, 7) != obj.EventEndDate.substr(0, 7)
                  ? obj.EventStartDate +
                    " to " +
                    obj.EventEndDate +
                    " " +
                    obj.EventTimezoneZ
                  : obj.EventStartDate + " " + obj.EventTimezoneZ;

              self.EventsData.push(obj);
              //------------------------------------------------------
              self.HostInfo = res.data.result.HostInfo;
              self.clientName = res.data.result.HostInfo.Name;
              self.clientLogoUrl = res.data.result.HostInfo.Logo;
              self.clientProfile = res.data.result.HostInfo.Profile;
              debugger;
              var eventBranding = {
                desktopBanner: res.data.result.EventInfo.EventBanner
                  ? res.data.result.EventInfo.EventBanner
                  : "",
                mobileBanner: res.data.result.EventInfo.EventBannerMobile
                  ? res.data.result.EventInfo.EventBannerMobile
                  : "",
                shareBanner: res.data.result.EventInfo.EventBannerShare
                  ? res.data.result.EventInfo.EventBannerShare
                  : "",
              };
              if (
                !eventBranding.desktopBanner ||
                !eventBranding.mobileBanner ||
                !eventBranding.shareBanner
              ) {
                if (res.data.result.banner) {
                  if (
                    !eventBranding.desktopBanner &&
                    res.data.result.banner["2048x88"]
                  ) {
                    eventBranding.desktopBanner =
                      res.data.result.banner["2048x88"];
                  }
                  if (
                    !eventBranding.mobileBanner &&
                    res.data.result.banner["750x103"]
                  ) {
                    eventBranding.mobileBanner =
                      res.data.result.banner["750x103"];
                  }
                  if (
                    !eventBranding.shareBanner &&
                    res.data.result.banner["1200x628"]
                  ) {
                    eventBranding.shareBanner =
                      res.data.result.banner["1200x628"];
                  }
                }
              }
              if (!eventBranding.shareBanner) {
                if (res.data.result.ogImage) {
                  if (
                    !eventBranding.shareBanner &&
                    res.data.result.ogImage["1200x628"]
                  ) {
                    eventBranding.shareBanner =
                      res.data.result.ogImage["1200x628"];
                  }
                }
              }

              if (self.eventID != self.getEventId()) {
                bus.$emit("SetGuestBannerURL", eventBranding);
              }

              self.getButtonBranding(self.hostName);
              self.getStaticFieldSettings(eventId);
              self.getCheckoutForm(true);
              ticketStatusUpdateTimer = setInterval(function () {
                self.getCheckoutForm(false);
              }, 5000);
            }
          });
      });
    this.getAdminSettings();
  },
  updated() {
    setTimeout(() => {
      self.resizeSessionFrame();
    }, 1000);
    setTimeout(() => {
      self.resizeSessionFrame();
    }, 2000);
  },
  // beforeRouteLeave(to, from, next) {
  //   //to, from, next
  //   //alert("beforeRouteLeave");
  //   if (ticketStatusUpdateTimer) {
  //     clearInterval(ticketStatusUpdateTimer);
  //   }
  //   next(true);
  // },
  beforeDestroy() {
    //alert("beforeDestroy");
    if (ticketStatusUpdateTimer) {
      clearInterval(ticketStatusUpdateTimer);
    }
  },
  methods: {
    IsTicketDisabled(registrationTypeId, selectedQuantity) {
      //registrationTypeId, selectedQuantity
      console.log(selectedQuantity);
      var result = false;
      var hasPaidTicket = false;
      var freeTicketSelected = false;
      var paidTicketSelected = false;
      var isSelected = false;

      for (let i = 0; i < self.RegistrationTypes.length; i++) {
        if (self.RegistrationTypes[i].FormType.toLowerCase() == "paid") {
          hasPaidTicket = true;
          if (self.RegistrationTypes[i].selectedQuantity > 0) {
            paidTicketSelected = true;
          }
        } else {
          if (self.RegistrationTypes[i].selectedQuantity > 0) {
            freeTicketSelected = true;
          }
        }
        if (
          self.RegistrationTypes[i].RegistrationTypeId == registrationTypeId &&
          self.RegistrationTypes[i].selectedQuantity > 0
        ) {
          isSelected = true;
          //self.RegistrationTypes[i].IsSelected = true;
        }
      }
      console.log(freeTicketSelected);
      if (hasPaidTicket && selectedQuantity == 0 && !isSelected) {
        for (let j = 0; j < self.RegistrationTypes.length; j++) {
          var item = self.RegistrationTypes[j];
          if (
            item.RegistrationTypeId == registrationTypeId &&
            item.selectedQuantity == 0
          ) {
            if (
              (freeTicketSelected && item.FormType.toLowerCase() == "paid") ||
              paidTicketSelected
            ) {
              result = true;
            }
          }
        }
      }
      // self.freeTicketSelected = freeTicketSelected;
      // self.paidTicketSelected = paidTicketSelected;
      return result;
    },
    SessionsLoaded() {
      //alert("SessionsLoaded");
      self.sessionsLoading = false;
      setTimeout(() => {
        self.resizeSessionFrame();
      }, 200);
      setTimeout(() => {
        self.resizeSessionFrame();
      }, 1000);
    },
    resizeSessionFrame() {
      if (document.getElementById("divPublicSessions")) {
        // document.getElementById("divPublicSessions").style.height =
        //   document.getElementById("divPublicSessions").contentWindow.document
        //     .documentElement.scrollHeight + "px";
        document.getElementById("divPublicSessions").style.height =
          document
            .getElementById("divPublicSessions")
            .contentWindow.document.body.getElementsByClassName(
              "session-list-container"
            )[0].scrollHeight +
          100 +
          "px";
      }
    },
    SpeakersLoaded() {
      //alert("SessionsLoaded");
      setTimeout(() => {
        self.resizeSpeakerFrame();
      }, 200);
      setTimeout(() => {
        self.resizeSpeakerFrame();
      }, 1000);
    },
    resizeSpeakerFrame() {
      if (document.getElementById("divPublicSpeakers")) {
        document.getElementById("divPublicSpeakers").style.height =
          document
            .getElementById("divPublicSpeakers")
            .contentWindow.document.body.getElementsByClassName(
              "public-speakers-wrap"
            )[0].scrollHeight +
          100 +
          "px";
      }
    },
    initScreen() {
      if (window.innerWidth > 768) {
        self.BannerURL = self.desktopBanner;
      } else {
        self.BannerURL = self.mobileBanner;
      }
    },
    ShowSocialShare() {
      if (self.EventsData.length > 0) {
        var shareEvent = new Object();
        shareEvent.ClientId = self.clientID;
        shareEvent.EventId = self.eventID;
        shareEvent.EventFullName = self.EventsData[0].EventFullName;
        shareEvent.Description = self.EventsData[0].Description;
        shareEvent.EventLogo = self.EventsData[0].EventLogo;
        shareEvent.EventBannerShare = self.EventsData[0].EventBannerShare;
        shareEvent.IsPublished = self.EventsData[0].IsPublished;
        bus.$emit("ShowSocialShare", shareEvent);
      }
    },
    getAdminSettings() {
      bus.$emit("toggleLoader", true);
      let eventID = self.eventID ? self.eventID : self.getEventId();
      let headers = {
        "Content-Type": "application/json",
        Authorization: `Bearer ${self.getSessionToken()}`,
        instanceId: "OA_UAT",
        clientId: self.getClientId(),
        eventId: eventID,
      };

      axios
        .get(APIs.SelfServiceEventConfig, { headers: headers })
        .then(function (res) {
          bus.$emit("toggleLoader", false);
          if (res.data.status == 0) {
            self.adminSettings = res.data.data;
          }
        })
        .catch(() => {
          bus.$emit("toggleLoader", false);
        });
    },

    OpenCheckoutForm() {
      if (self.ticketStatus > 0) {
        return;
      }
      $("#register_popup").modal({ backdrop: "static" }, "show");
      // ticketStatusUpdateTimer = setInterval(function () {
      //   self.getCheckoutForm(false);
      // }, 5000);
    },
    CloseCheckoutForm() {
      $("#register_popup").modal("hide");
      // if (ticketStatusUpdateTimer) {
      //   clearInterval(ticketStatusUpdateTimer);
      // }
    },
    getStaticFieldSettings: function (eventId) {
      var evntCol = "OA_UAT_" + self.clientID + eventId;
      const storage = firebase.storage();
      const storageRef = storage.ref();
      const objStaticFieldRef = storageRef.child(
        evntCol + "/Registration/DefaultRegFormSettings.JSON"
      );

      objStaticFieldRef.getDownloadURL().then((url) => {
        axios.get(url).then((response) => {
          console.log(
            "static Response Data:- " +
              JSON.stringify(response.data.LandingPageShowEventListLink)
          );
          //------------------------------------------------------------------
          self.ShowHostedByPanel = response.data.LandingPageShowHostedByPanel;
          self.config.LandingPageShowHostedByPanel =
            response.data.LandingPageShowHostedByPanel;
          self.ShowEventListLink = response.data.LandingPageShowEventListLink;
          self.config.LandingPageShowEventListLink =
            response.data.LandingPageShowEventListLink;
          //-------------------------------------------------------------------------------------
        });
      });
    },
    getCheckoutForm: function (firstLoad) {
      if (firstLoad) {
        bus.$emit("toggleLoader", true);
      }
      var evntCol = "OA_UAT_" + self.clientID + self.eventID;
      const storage = firebase.storage();
      const storageRef = storage.ref();
      const objStaticFieldRef = storageRef.child(
        evntCol + "/Registration/CheckoutForms.JSON"
      );
      // var url =
      //   "https://resources.e2m.live/" +
      //   storageRef.bucket +
      //   "/" +
      //   evntCol +
      //   "/Registration/CheckoutForms.JSON";
      objStaticFieldRef
        .getDownloadURL()
        .then((url) => {
          axios
            .get(url)
            .then((response) => {
              var ticketList = [];
              var formsRegTypes = [];
              var openTicketCount = 0;
              var saleNotStarted = 0;
              var soldTicketCount = 0;
              var saleEndedCount = 0;
              self.CheckoutForms = response.data.CheckoutForms;
              self.Config = response.data.Config;
              self.CheckoutForms.forEach((cf) => {
                if (cf.IsPublished) {
                  cf.RegistrationTypes.map((rt) => {
                    formsRegTypes.push(rt.RegistrationTypeId);
                  });
                }
              });
              response.data.RegistrationTypes.forEach((item) => {
                if (
                  formsRegTypes.includes(item.RegistrationTypeId) &&
                  item.IsPublished
                ) {
                  ticketList.push(item.RegistrationTypeId);
                  item["selectedQuantity"] = 0;
                  item["isInActiveTicket"] = false;
                  item["InActiveMessage"] = "";
                  if (Number(item.Quantity) <= 0) {
                    item["isInActiveTicket"] = true;
                    item["InActiveMessage"] = "All Tickets Sold!";
                    soldTicketCount++;
                  } else if (
                    moment().isBefore(
                      moment(
                        item.SaleStartDate._seconds
                          ? item.SaleStartDate._seconds * 1000
                          : item.SaleStartDate
                      )
                    )
                  ) {
                    item["isInActiveTicket"] = true;
                    item["InActiveMessage"] = "Sale Not Started!";
                    saleNotStarted++;
                  } else if (
                    moment().isAfter(
                      moment(
                        item.SaleEndDate._seconds
                          ? item.SaleEndDate._seconds * 1000
                          : item.SaleEndDate
                      )
                    )
                  ) {
                    item["isInActiveTicket"] = true;
                    item["InActiveMessage"] = "Sale Ended!";
                    saleEndedCount++;
                  } else {
                    openTicketCount++;
                  }
                  var regTypes = self.RegistrationTypes.filter(function (
                    regType
                  ) {
                    return (
                      regType.RegistrationTypeId == item.RegistrationTypeId
                    );
                  });
                  if (regTypes.length == 0) {
                    // if (
                    //   item.RegistrationType == "Attendee" ||
                    //   item.RegistrationType ==
                    //     "PhD/MSc Student *, post-graduate *‡, post-Doc *‡ (One Day):"
                    // ) {
                    //   item.FormType = "FREE";
                    // }
                    if (item.FormType.toLowerCase() == "paid") {
                      item.MaxLimit = 1;
                    }
                    self.RegistrationTypes.push(item);
                  } else {
                    regTypes[0]["isInActiveTicket"] = item["isInActiveTicket"];
                    regTypes[0]["InActiveMessage"] = item["InActiveMessage"];
                    regTypes[0]["Quantity"] = item["Quantity"];
                    regTypes[0]["MinLimit"] = item["MinLimit"];
                    if (item.FormType.toLowerCase() == "paid") {
                      item.MaxLimit = 1;
                    } else {
                      regTypes[0]["MaxLimit"] = item["MaxLimit"];
                    }
                  }
                }
              });
              if (firstLoad) {
                bus.$emit("toggleLoader", false);
              } else {
                if (ticketList.length > 0) {
                  self.RegistrationTypes = self.RegistrationTypes.filter(
                    function (regType) {
                      return ticketList.includes(regType.RegistrationTypeId);
                    }
                  );
                }
              }

              self.RegistrationTypes = self.RegistrationTypes.sort(function (
                a,
                b
              ) {
                let v1 = a.CreatedDate._seconds;
                let v2 = b.CreatedDate._seconds;
                return v1 < v2 ? -1 : v1 > v2 ? 1 : 0;
              });
              self.ticketStatus = 0;
              if (openTicketCount == 0) {
                if (saleNotStarted > 0) {
                  self.ticketStatus = 1; //Sale Not Started!
                } else if (saleEndedCount > 0) {
                  self.ticketStatus = 3; //Sale Ended!
                } else if (soldTicketCount > 0) {
                  self.ticketStatus = 2; //All Tickets Sold!
                }
              }
              self.CheckRegEnabledStatus();
            })
            .catch((error) => {
              if (firstLoad) {
                bus.$emit("toggleLoader", false);
              }

              console.log("getCheckoutForm get: " + error);
              self.getCheckoutFormsRetryCount++;
              if (self.getCheckoutFormsRetryCount < 6) {
                self.getCheckoutForm();
              } else {
                //location.reload();
                router.push("/events");
              }
              //alert("getCheckoutForms get: " + self.getCheckoutFormsRetryCount);
            });
        })
        .catch((error) => {
          console.log("getCheckoutForm getDownloadURL: " + error);
          self.getCheckoutFormsRetryCount++;
          if (self.getCheckoutFormsRetryCount < 6) {
            self.getCheckoutForm();
          } else {
            //location.reload();
            //router.push("/events");
          }
          // alert(
          //   "getCheckoutForm getDownloadURL: " + self.getCheckoutFormsRetryCount
          // );
        });
    },
    GetTimeByZone: function (strDateTime, timeZone) {
      strDateTime = moment(strDateTime).format("YYYY-MM-DD HH:mm");
      var strtDate = moment.tz(strDateTime, timeZone);
      strtDate._d.setMinutes(strtDate._d.getMinutes() - strtDate._offset);
      return strtDate._d;
    },
    getButtonBranding: function (hostName) {
      var path;
      // if (hostName.toLowerCase().indexOf("uat") > -1) {
      //   path = "https://resources.e2m.live/uate2monair.appspot.com/";
      // } else {
      path = APIs.googleSoragePath;
      // }
      // alert("path")
      // alert(path)
      axios
        .get(
          path + "OA_UAT%2FClients%2FHosts%2F" + hostName + ".json?alt=media"
        )
        .then((res) => {
          self.btnBackColor = res.data.LoginAssets.loginButtonFillColor;
          self.btntextColor = res.data.LoginAssets.loginButtonTextColor;
          //$("#btnRegister").css("background-color", self.btnBackColor);
          //$("#btnRegister").css("color", self.btntextColor);
          $(".acnhDescription").css("border-color", self.btnBackColor);
          self.CheckRegEnabledStatus();
        });
      //------------------------------------------------------------------------------
    },
    CheckRegEnabledStatus() {
      //alert("AllowRegistration: "+self.AllowRegistration);
      if (!self.AllowRegistration) {
        //alert("1");
        //var btnRegister = document.getElementById("btnRegister");
        //btnRegister.setAttribute("disabled", "disabled");
        //btnRegister.textContent = "Registration Closed";
        //btnRegister.style.backgroundColor = "grey";
      }
    },
    goForEventList: function () {
      //router.push({ name: "EventListReg" });
      router.push({
        path: "/events/" + self.clientID,
      });
    },
    goForLogin: function () {
      router.push({ name: "Login" });
    },
    directFormOpen() {
      if (self.ticketStatus > 0) {
        return;
      }
      if (
        this.RegistrationTypes.length == 1 &&
        this.RegistrationTypes[0].MaxLimit == 1
      ) {
        this.RegistrationTypes[0]["selectedQuantity"] = 1;
        this.goForRegister();
      }
    },
    goForRegister() {
      if (self.ticketStatus > 0) {
        return;
      }
      self.IsSubmitting = true;
      let selectedRegistrationTypes = this.RegistrationTypes.filter(function (
        item
      ) {
        return item.selectedQuantity > 0;
      });
      let regTypes = new Object();
      let formRegTypes = [];
      let showRegistrationTypes = true;
      if (
        this.RegistrationTypes.length == 1 &&
        this.RegistrationTypes[0].selectedQuantity == 1
      ) {
        showRegistrationTypes = false;
      }
      for (let item of selectedRegistrationTypes) {
        //if(item.selectedQuantity > 1){
        for (let i = 1; i <= item.selectedQuantity; i++) {
          item["FormLabel"] = `${item.RegistrationType} Registrant ${i}`;
          formRegTypes.push({ ...item });
        }
        //}
        //else{
        //  item['FormLabel'] = `${item.RegistrationType} Registrant`;
        //  regTypes.push(item);
        //}
        regTypes[item.RegistrationTypeId] = item.selectedQuantity;
      }

      let checkoutPice = this.getsubtotal
        ? (Number(this.getsubtotal) + Number(this.taxPrice)).toFixed(2)
        : Number(this.getsubtotal).toFixed(2);

      if (selectedRegistrationTypes.length) {
        let headers = {
          "content-type": "application/json",
        };
        let requestData = {
          key: {
            instanceId: "OA_UAT",
            clientId: self.clientID,
            eventId: self.eventID,
          },
          data: regTypes,
        };
        axios
          .post(APIs.InitRegisterAttendee, requestData, {
            headers: headers,
          })
          .then((responseData) => {
            console.log(responseData);
            if (responseData && responseData.data) {
              if (responseData.data.status == 0) {
                if (this.$refs.close_modal) {
                  this.$refs.close_modal.click();
                }
                router.push({
                  //path: `/regv3/${self.eventID}`,
                  name: "Reg3",
                  params: {
                    e: self.eventID,
                    bundleId: responseData.data.bundleId,
                    expiry: responseData.data.expiry,
                    regTypes: formRegTypes,
                    showRegistrationTypes: showRegistrationTypes,
                    checkoutPice: Number(checkoutPice).toFixed(2),
                  },
                  query: {
                    app: self.app,
                  },
                });
              } else {
                self.showSnackbar(responseData.data.msg, "error", "top");
              }
            } else {
              self.showSnackbar("Something went wrong!", "error", "top");
            }
            self.IsSubmitting = false;
          })
          .catch((error) => {
            self.IsSubmitting = false;
            console.log(error);
          });
        console.log(checkoutPice);
      } else {
        self.showSnackbar("Select Atleast One Ticket!", "error", "top");
        self.IsSubmitting = false;
      }
    },
    goForRegister1() {
      let selectedRegistrationTypes = this.RegistrationTypes.filter(function (
        item
      ) {
        return item.selectedQuantity > 0;
      });
      let regTypes = new Object();
      var flag = false;
      for (let item of selectedRegistrationTypes) {
        //if(item.selectedQuantity > 1){
        //  for (let i = 1; i <= item.selectedQuantity; i++){
        //    item['FormLabel'] = `${item.RegistrationType} Registrant ${i}`;
        //    //regTypes.push({...item});
        //  }
        //}
        //else{
        //  item['FormLabel'] = `${item.RegistrationType} Registrant`;
        //  regTypes.push(item);
        //}
        if (item.selectedQuantity > 0) {
          flag = true;
          regTypes[item.id] = item.selectedQuantity;
        }
      }

      let checkoutPice = this.getsubtotal
        ? (Number(this.getsubtotal) + Number(this.taxPrice)).toFixed(2)
        : Number(this.getsubtotal).toFixed(2);

      if (selectedRegistrationTypes.length && flag) {
        //
        let headers = {
          "content-type": "application/json",
        };
        let requestData = {
          key: {
            instanceId: "OA_UAT",
            clientId: self.clientID,
            eventId: self.eventID,
          },
          data: regTypes,
        };
        axios
          .post(APIs.InitRegisterAttendee, requestData, {
            headers: headers,
          })
          .then((responseData) => {
            console.log(responseData);
          })
          .catch((error) => {
            console.log(error);
          });
        if (this.$refs.close_modal) {
          this.$refs.close_modal.click();
        }
        //router.push({
        //  //path: `/regv3/${self.eventID}`,
        //  name: "Reg3",
        //  params: {
        //    e: self.eventID,
        //    regTypes: regTypes,
        //    checkoutPice: Number(checkoutPice).toFixed(2),
        //  },
        //});
        console.log(checkoutPice);
      } else {
        alert("Select Atleast One Ticket!");
      }
    },
  },
};
</script>
